export default {"src":"/_next/static/media/se.8c524609.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};